import React, {useState} from "react";
import {OffCanvas, OffCanvasMenu, OffCanvasBody} from "react-offcanvas";
import Avatar from "../Components/Avatar";

import {setWatchIsActive, setReadIsActive, setLearnIsActive} from "../../Features/Misc/navBarSlice"
import {activeReset} from "../../Features/Misc/activeSlice";
import {useDispatch, useSelector} from "react-redux";
import {v4 as uuidv4} from "uuid";
import {setDashBoardIsActive} from "../../Features/Misc/activeSlice";
import {logOut, reset} from "../../Features/Auth/authSlice"
import {resetLoginStep} from "../../Features/Misc/loginSlice";


export default function MiniOffCanvas() {
    const dispatch = useDispatch()
    const {first_name, last_name} = useSelector((state) => state.auth.user)

    //user controls
    const userControls = [
        {title: "My Account", icon: "ri-account-circle-line"},
        {title: "Settings", icon: "ri-settings-3-line"},
    ]

    const links = [
        {
            title: "New", icon: "ri-notification-2-line", func: () => {
                setMenuOpened(false)
            }
        },
        {
            title: "Videos", icon: "ri-video-line", func: () => {
                setMenuOpened(false);
                dispatch(setWatchIsActive());
                dispatch(setDashBoardIsActive())
            }
        },
        {
            title: "Read", icon: "ri-book-read-line", func: () => {
                setMenuOpened(false);
                dispatch(setReadIsActive());
                dispatch(setDashBoardIsActive())
            }
        },
        {
            title: "Webinars", icon: "ri-lightbulb-line", func: () => {
                setMenuOpened(false);
                dispatch(setLearnIsActive());
                dispatch(setDashBoardIsActive())
            }
        }
    ]


    //OffCanvas constants
    const [menuOpened, setMenuOpened] = useState(false)
    const handleClick = () => {
        setMenuOpened(!menuOpened)
    }

    const handleLogout = () => {
        dispatch(reset());
        dispatch(resetLoginStep());
        dispatch(activeReset());
        dispatch(logOut());
    }


    return (
        <OffCanvas

            transitionDuration={20}
            effect={"overlay"}
            isMenuOpened={menuOpened}
            position={"right"}
            className={`w-72`}
        >
            <OffCanvasBody>
                <div onClick={() => handleClick()}>
                    <i className="ri-menu-line text-gold-accent text-4xl cursor-pointer"></i>
                </div>
            </OffCanvasBody>

            <OffCanvasMenu
                className={`z-50  flex flex-col bg-purple-slumber p-4  ${menuOpened ? "w-7/12 h-full" : "w-0 h-full"}`}>

                <div className={` cursor-pointer w-full text-2xl flex flex-row items-center justify-end `}
                     onClick={() => handleClick()}>
                    <i className="text-3xl ri-close-line flex items-center text-gold-accent"></i>
                </div>


                <div className="offCanvasMenu-user bg-purple-slumber rounded-bl-mega text-white  ">
                    <div
                        className="offCanvasMenu-user-inner row-start-2 row-end-12 col-start-2 col-end-11 flex flex-col p-4 gap-10">


                        <div className="avatarRow flex flex-row gap-4 items-center ">
                            <Avatar height={`h-10`} width={`w-10`} type={`user`}/>
                            {/*changed this*/}
                            <div className="text-lg sm:text-xl" style={{textTransform: 'capitalize'}}>
                                {first_name.charAt(0).toUpperCase() + first_name.slice(1).toLowerCase()}
                            </div>
                        </div>

                        {/*<div className={`text-base `}></div>*/}


                        <div className={`text-lg lg:text-2xl bg-purple-slumber cursor-pointer flex flex-col gap-4`}>
                            {links && links.map((link) => {
                                    const {title, icon, func} = link
                                    //temp fix - Removing New as it doesn't do anything
                                    if (title !== "New") {
                                        return (
                                            <div key={uuidv4()} onClick={() => func()}
                                                 className={`w-full h-12 cursor-pointer  rounded-lg gap-4 flex p-4 flex-row justify-start items-center `}>
                                                <i className={icon}></i>
                                                <div>{title}</div>
                                            </div>
                                        )
                                    } else {
                                        return null
                                    }
                                }
                            )}
                        </div>


                        <div className={`text-lg lg:text-2xl bg-purple-slumber cursor-pointer flex flex-col gap-4`}>
                            {userControls && userControls.map((userControl) => {
                                    const {title, icon} = userControl


                                    return (
                                        <div key={uuidv4()}
                                             className={`w-full h-14 rounded-lg gap-4 flex p-4 flex-row justify-start items-center `}>
                                            <i className={icon}></i>
                                            <p>{title}</p>
                                        </div>
                                    )
                                }
                            )}


                            <div
                                className={`bg-purple-slumber w-full h-14 cursor-pointer rounded-lg gap-4 flex p-4 flex-row justify-start items-center hover:opacity-60 transition-opacity duration-300`}>
                                <i className="ri-logout-box-line"></i>
                                <div onClick={() => handleLogout()} className="logout">Log Out</div>
                            </div>
                        </div>


                        {/*<div className="w-full h-48 bg-search-text-grey rounded-lg flex flex-col items-center py-3 justify-center">*/}
                        {/*    <i className="ri-lock-unlock-line text-purple-dashboard"></i>*/}
                        {/*    <div className={`text-base`}>Unlock</div>*/}
                        {/*    <div className={`text-base mb-6`}>Premium Content</div>*/}
                        {/*    <div className="w-full px-8">*/}
                        {/*        <div onClick={() => console.log("here we will redirect to the premium purchase page?")} className="flex flex-row gap-2 justify-center py-2 items-center rounded-full bg-purple-dashboard">*/}
                        {/*            <i className="text-base text-white ri-add-line "></i>*/}
                        {/*            <div className={`text-base text-white  `}>Buy Premium</div>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}

                        {/*</div>*/}

                    </div>

                </div>

            </OffCanvasMenu>
        </OffCanvas>
    );

}
